import { FunctionComponent } from 'react';
import { Badge, Card, CheckboxProps } from '@shopify/polaris';
import { CardTitleSmall, HelpText } from '@components/ui/common';
import { ColumnContainer } from '@components/ui/container/common';
import { Checkbox, Separator } from '@ui';

export type PosSettingsProps = {
  includeMissingEmail?: boolean;
  onChangeIncludeMissingEmail: CheckboxProps['onChange'];
  onChangePosOrdersOnly: CheckboxProps['onChange'];
  posOrdersOnly?: boolean;
};

const PosSettings: FunctionComponent<PosSettingsProps> = (props) => {
  const {
    includeMissingEmail,
    onChangeIncludeMissingEmail,
    onChangePosOrdersOnly,
    posOrdersOnly,
  } = props;
  return (
    <Card
      sectioned
      title={
        <CardTitleSmall>
          Point of Sale (POS) Settings <Badge>Beta</Badge>
        </CardTitleSmall>
      }
    >
      <ColumnContainer>
        <Checkbox
          label="POS orders only"
          id="posOrdersOnly"
          checked={posOrdersOnly}
          onChange={onChangePosOrdersOnly}
        />
        <br />
        <HelpText>
          Only orders that are identified as POS orders will qualify for this
          campaign. Customers will receive an email from Givz to complete their
          donation.
        </HelpText>
        {posOrdersOnly && (
          <>
            <Separator fullWidth />
            <Checkbox
              label="Include POS orders when email is missing"
              id="includeMissingEmail"
              checked={includeMissingEmail}
              onChange={onChangeIncludeMissingEmail}
            />
            <br />
            <HelpText>
              Including POS orders that are missing an email is only appropriate
              when Instant Donations or Allocate Unused Donations is enabled.
            </HelpText>
          </>
        )}
      </ColumnContainer>
    </Card>
  );
};

export default PosSettings;
